import { Card } from "@mui/material";
import Modal from "components/modal/Modal";
import Table from "components/table/Table";
import { useModalState } from "hooks/useModalState";
import { useMemo, useState } from "react";
import { useGetCallFlowDetail } from "service/query/call-flow.query";

import CallFlowDetailModal from "./CallFlowDetailModal";

const CallFlowHistoryModal = ({ open, onClose, historyRecords }) => {
  const [currentItem, setCurrentItem] = useState();
  const viewDetailModal = useModalState();
  const { data: callFlowDetail, isFetching } = useGetCallFlowDetail(
    currentItem?.id,
    {
      enabled: !!currentItem?.id,
    }
  );

  const sortedHistoryRecords = useMemo(
    () =>
      historyRecords
        ? [...historyRecords].sort(
            (a, b) => parseFloat(b.version) - parseFloat(a.version)
          )
        : [],
    [historyRecords]
  );

  const columns = useMemo(
    () => [
      {
        id: "contactCenterInfo.name",
        name: "Bộ phận",
      },
      { id: "version", name: "Version" },
      { id: "status", name: "Trạng thái", type: "status" },
      {
        id: "updatedAt",
        name: "Thời gian cập nhật",
        type: "datetime",
      },
    ],
    []
  );

  const handleOpenModalViewHistory = (record) => {
    setCurrentItem(record);
    viewDetailModal.openModal();
  };

  const handleCloseModalDetail = () => {
    setCurrentItem(null);
    viewDetailModal.closeModal();
  };

  return (
    <Modal open={open} title="Lịch sử thay đổi" onClose={onClose} maxWidth="md">
      <Card sx={{ mt: 2 }}>
        <Table
          columns={columns}
          data={sortedHistoryRecords}
          showHoverRow
          actionColumn={{
            onView: handleOpenModalViewHistory,
            colorButtonView: "primary",
          }}
        />
      </Card>

      {viewDetailModal.open && (
        <CallFlowDetailModal
          onClose={handleCloseModalDetail}
          currentItem={callFlowDetail}
          open={viewDetailModal.open}
          loading={isFetching}
          mode="view"
        />
      )}
    </Modal>
  );
};

export default CallFlowHistoryModal;
